import { EInvoiceAssuranceType } from "./e-invoice-assurance-type.enum";

export class TaxRepresentativeDto {
  Name: string | null;
  TvaNumber: string | null;
  Address: string | null;
  PostCode: string | null;
  City: string | null;
  Country: string | null;
  CountryAlpha2Code: string | null;
}

export class SaveTaxRepresentativeRequest {
  constructor(request: SaveTaxRepresentativeRequest) {
    if (request != null) {
      this.Name = request.Name;
      this.Address = request.Address;
      this.City = request.City;
      this.Country = request.Country;
      this.CountryAlpha2Code = request.CountryAlpha2Code;
      this.PostCode = request.PostCode;
      this.TvaNumber = request.TvaNumber;
    }
  }
  Name: string;
  Address: string;
  PostCode: string;
  City: string;
  Country: string;
  CountryAlpha2Code: string;
  TvaNumber: string;
}

export class EInvoiceTaxRepresentative {
  IsTaxRepresentative: boolean;
  TaxRepresentative: TaxRepresentativeDto | null;
}

export class EInvoiceCompanyModel {
  Id: number;
  Name: string;
  Siret: string | null;
  TvaNumber: string | null;
  Email: string;
  Address: string;
  PostCode: string;
  City: string;
  Country: string;
  CountryAlpha2Code: string;
  IsDeleted: boolean | null;
  Capital: number | null;
  Rcs: string;
  LegalStatus: string;
  IsJudicialLiquidation: boolean;
  IsTaxRepresentative: boolean;
  TaxRepresentative: TaxRepresentativeDto | null;
  AssuranceType: EInvoiceAssuranceType | null;
  AssuranceName: string | null;
  AssuranceContractIdentifier: string | null;
  AssuranceGeographicCoverage: string | null;
  LogoUrl:string | null;

}

export * from "./e-invoice-assurance-type.enum";
